import React, { useContext } from "react"

import { Grid } from "@material-ui/core"
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
} from "App/Component/ui"

import {
  urlGetAsuransi,
  urlGetJenisLayanan,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP,
  JENIS_PENERIMA,
} from "."

import { useSelectOption } from "App/hooks"

import { TYPE_INSTANCE2 } from "App/constants"
import { FormContext } from "../context/FormContext"
import { isNull, ToOneMonthAfterToday } from "App/utils/helpers"
import { useSelector } from "react-redux"

export default function FormInputRekapTagihan() {
  const { formData, setFormData, formError } = useContext(FormContext)
  const jenisLayanan = useSelectOption(true, urlGetJenisLayanan, TYPE_INSTANCE2)
  const master = useSelector(({ master }) => master)

  const asuransi = useSelectOption(true, urlGetAsuransi, TYPE_INSTANCE2)

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    })
  }

  const changeSelect = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    })
  }

  return (
    <>
      <form action="">
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <InputTextMaster
              name="rekap_tagihan_id"
              label="ID"
              id="rekap_tagihan_id"
              placeholder="ID"
              disabled={true}
              readOnly={true}
              value={formData.rekap_tagihan_id}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="no_surat"
              label="NO. SURAT"
              id="idgl"
              placeholder="No. Surat"
              disabled={true}
              readOnly={true}
              value={formData.no_surat}
            />
          </Grid>
          <Grid item sm={4}>
            <InputTextMaster
              name="no_resi"
              label="NO. RESI"
              id="no_resi"
              placeholder="No. Resi"
              value={formData.no_resi}
              onChange={handleChange("no_resi")}
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formData.tanggal_rekap}
              label="TANGGAL"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_rekap: e,
                  tanggal_periode_akhir: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_rekap: e,
                  tanggal_periode_akhir: e,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formData.tanggal_periode_awal}
              label="TANGGAL PERIODE"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              dateFormat="dd/MM/yyyy"
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_periode_awal: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_periode_awal: e,
                })
              }
              withPeriode={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "1px solid #EAEAEA",
                  background: "#fff",
                  padding: "0 0.8rem 0 0.8rem",
                  cursor: "pointer",
                  // borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                s/d
              </button>
              <InputReactDatepicker
                selected={formData.tanggal_periode_akhir}
                label=""
                dateFormat="dd/MM/yyyy"
                minDate={new Date(formData.tanggal_periode_awal)}
                disabled={
                  formData.status_proses ===
                  STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                    ? true
                    : false
                }
                handleChangeToday={(e) =>
                  setFormData({
                    ...formData,
                    tanggal_periode_akhir: e,
                  })
                }
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    tanggal_periode_akhir: e,
                  })
                }
                withParentPeriode={true}
              />
            </InputReactDatepicker>
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formData.tanggal_tagih}
              label="TANGGAL TAGIH"
              dateFormat="dd/MM/yyyy"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_tagih: e,
                  tanggal_jatuh_tempo: ToOneMonthAfterToday(e),
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_tagih: e,
                  tanggal_jatuh_tempo: ToOneMonthAfterToday(e),
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formData.tanggal_jatuh_tempo}
              label="TANGGAL JATUH TEMPO"
              dateFormat="dd/MM/yyyy"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  tanggal_jatuh_tempo: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  tanggal_jatuh_tempo: e,
                })
              }
            />
          </Grid>
          <Grid item md={3}>
            <InputOptionMaster
              name="company_id"
              label="PERUSAHAAN"
              id="company_id"
              withSearch={true}
              data={master.perusahaan.list_select}
              value={formData.company_id}
              labelValue={formData.company_name}
              // error={true}
              // message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    company_id: null,
                    company_name: "Pilih Perusahaan",
                  })
                } else {
                  setFormData({
                    ...formData,
                    company_id: e.value,
                    company_name: e.label,
                  })
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="jenis_penerima"
              label="INSTANSI ASURANSI"
              id="jenis_penerima"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              withSearch={true}
              data={JENIS_PENERIMA}
              value={formData.jenis_asuransi_id}
              labelValue={formData.jenis_asuransi_nama}
              error={formError?.jenis_asuransi_id}
              onChange={(e) => {
                changeSelect(e, "jenis_asuransi_id", "jenis_asuransi_nama")
                setFormData({
                  ...formData,
                  jenis_asuransi_id: isNull(e?.value) ? null : e?.value,
                  jenis_asuransi_nama: isNull(e?.label)
                    ? "Pilih Instansi Asuransi"
                    : e?.label,
                  asuransi_id: null,
                  asuransi_nama: "Pilih Asuransi",
                })
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="asuransi_id"
              label="ASURANSI"
              id="asuransi_id"
              error={formError?.asuransi_id}
              message={formError?.asuransi_id}
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              withSearch={true}
              data={asuransi}
              value={formData.asuransi_id}
              labelValue={formData.asuransi_nama}
              onChange={(e) =>
                isNull(e)
                  ? setFormData({
                      ...formData,
                      asuransi_id: null,
                      asuransi_nama: "Pilih Asuransi",
                    })
                  : changeSelect(e, "asuransi_id", "asuransi_nama")
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="jenis_rawat_id"
              label="JENIS RAWAT"
              id="jenis_rawat_id"
              withSearch={true}
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              data={jenisLayanan}
              error={formError?.jenis_rawat_id}
              message={formError?.jenis_rawat_id}
              value={formData.jenis_rawat_id}
              labelValue={formData.jenis_rawat_nama}
              onChange={(e) =>
                isNull(e)
                  ? setFormData({
                      ...formData,
                      jenis_rawat_id: null,
                      jenis_rawat_nama: "Pilih Jenis Rawat",
                    })
                  : changeSelect(e, "jenis_rawat_id", "jenis_rawat_nama")
              }
            />
          </Grid>
          {/* <Grid item sm={3}>
            <InputOptionMaster
              name="status_proses"
              label="STATUS PROSES"
              id="status_proses"
              disabled={
                formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP
                  ? true
                  : false
              }
              withSearch={true}
              data={STATUS_PROSES_REKAP_TAGIHAN}
              value={formData.status_proses}
              labelValue={formData.status_proses_name}
              onChange={(e) => isNull(e) ? setFormData({ ...formData, status_proses:null, status_proses_name:"Pilih Status Proses"}) : changeSelect(e, "status_proses", "status_proses_name")}
            />
          </Grid> */}
        </Grid>
      </form>
    </>
  )
}
